
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as teamM442UbwkSdIRoaJI7s1WHoDmkAgbPX__bsNWFWsNxJAMeta } from "/vercel/path0/app/pages/team.vue?macro=true";
import { default as indexXNEFQ_BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta } from "/vercel/path0/app/pages/index.vue?macro=true";
import { default as showcaseh9CKeTtaFu9RmDzFH_LBfcr7mWlQo4cXJ_whU51AJZAMeta } from "/vercel/path0/app/pages/showcase.vue?macro=true";
import { default as templates3JuNNrKRIC9lVJc5Ic10i1NSu1qDr2BdnYi8Y3c2wroMeta } from "/vercel/path0/app/pages/templates.vue?macro=true";
import { default as indexaRLkqFYQWbP0_Tby87Q1jWH11wlsDi_Wpy86jOxYmNIMeta } from "/vercel/path0/app/pages/blog/index.vue?macro=true";
import { default as design_45kitAdXw4NbEOHmPEanpya2nd51NLlm_pYDFenBlmwVXLt4Meta } from "/vercel/path0/app/pages/design-kit.vue?macro=true";
import { default as jobsui3znLVjPPi1uvIO7NuS_QJIZwM8xy_LgNPI4ttmQTUMeta } from "/vercel/path0/app/pages/enterprise/jobs.vue?macro=true";
import { default as support7YNSDjkZ1vNxFq7kPcTjA0Ia5kB_rl9F5fxFoZzHiPQMeta } from "/vercel/path0/app/pages/enterprise/support.vue?macro=true";
import { default as sponsorsqSnf0SJ24yxiQ_ITbF0iFg2TQ4pmCaAwaGHmnSOJVgMMeta } from "/vercel/path0/app/pages/enterprise/sponsors.vue?macro=true";
import { default as indexdh5KEN3wnXEhpLEGUlAG2S9f0rx3sSUyx4CAF6Uvbw8Meta } from "/vercel/path0/app/pages/enterprise/agencies/index.vue?macro=true";
import { default as _91slug_93JKyIiTBK8ePEQRrGalD6GzjrE_k30_eVSubgbkdVX6QMeta } from "/vercel/path0/app/pages/enterprise/agencies/[slug].vue?macro=true";
import { default as enterprise9ZB5_KjAa7UI_UGnVlj_3tEPjG0IO0V6UQoFvkfKQEAMeta } from "/vercel/path0/app/pages/enterprise.vue?macro=true";
import { default as newslettern4GOb5QWXQJ5kM06NFdIlERlYnW_9hqvAMGSs5DZn3kMeta } from "/vercel/path0/app/pages/newsletter.vue?macro=true";
import { default as indexQYufR705eSA0Alb_DtstO3BC68H4U3RBsMP5nSZmzYAMeta } from "/vercel/path0/app/pages/admin/index.vue?macro=true";
import { default as loginOl84J9_AHH9A75q8OlyZtme3OFntWQgXeSBZ5ez230UMeta } from "/vercel/path0/app/pages/admin/login.vue?macro=true";
import { default as _91slug_93V5fV_c16JVJ6sOuGL8Wo8dfppaMqN_wRcqM9kt2Zm5YMeta } from "/vercel/path0/app/pages/blog/[slug].vue?macro=true";
import { default as indexicxDjlXg087w7w6CUqyqwMldMLtROSaz6jMBwBw1JcUMeta } from "/vercel/path0/app/pages/deploy/index.vue?macro=true";
import { default as _91slug_93_ksw8fq6FRuQ4uaNnbYgAzfG0fklryQ204pz9_RDvaUMeta } from "/vercel/path0/app/pages/deploy/[slug].vue?macro=true";
import { default as indexujR_H8Cu1L2s4oCJBKSzWX3Bn1mbWcGA_oIqsbBAGR8Meta } from "/vercel/path0/app/pages/modules/index.vue?macro=true";
import { default as video_45coursesNEh0ujp9_IaJpKCGLKWycaqjaVK9Cj04AvwlHbaheL8Meta } from "/vercel/path0/app/pages/video-courses.vue?macro=true";
import { default as _91_46_46_46slug_93OUNKk7AMQ1VVXePpxx0zUP0UVhd9HLJ7HMG1pdCiK_IMeta } from "/vercel/path0/app/pages/docs/[...slug].vue?macro=true";
import { default as _91slug_93br5bsBMaFUldu9ZW3X_bIirDQhXcQ74oasqLdJl3UNUMeta } from "/vercel/path0/app/pages/modules/[slug].vue?macro=true";
import { default as component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@4.2.1_@libsql+client@0.15.15_@parcel+watcher@2.5.1_@types+node@24.10.0_@vercel+blo_d6f82ecef7735b0ae36305d0e860f4a4/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk } from "/vercel/path0/node_modules/.pnpm/nuxt@4.2.1_@libsql+client@0.15.15_@parcel+watcher@2.5.1_@types+node@24.10.0_@vercel+blo_d6f82ecef7735b0ae36305d0e860f4a4/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "team",
    path: "/team",
    meta: teamM442UbwkSdIRoaJI7s1WHoDmkAgbPX__bsNWFWsNxJAMeta || {},
    component: () => import("/vercel/path0/app/pages/team.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexXNEFQ_BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta || {},
    component: () => import("/vercel/path0/app/pages/index.vue")
  },
  {
    name: "showcase",
    path: "/showcase",
    meta: showcaseh9CKeTtaFu9RmDzFH_LBfcr7mWlQo4cXJ_whU51AJZAMeta || {},
    component: () => import("/vercel/path0/app/pages/showcase.vue")
  },
  {
    name: "templates",
    path: "/templates",
    meta: templates3JuNNrKRIC9lVJc5Ic10i1NSu1qDr2BdnYi8Y3c2wroMeta || {},
    component: () => import("/vercel/path0/app/pages/templates.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexaRLkqFYQWbP0_Tby87Q1jWH11wlsDi_Wpy86jOxYmNIMeta || {},
    component: () => import("/vercel/path0/app/pages/blog/index.vue")
  },
  {
    name: "design-kit",
    path: "/design-kit",
    meta: design_45kitAdXw4NbEOHmPEanpya2nd51NLlm_pYDFenBlmwVXLt4Meta || {},
    component: () => import("/vercel/path0/app/pages/design-kit.vue")
  },
  {
    name: "enterprise",
    path: "/enterprise",
    component: () => import("/vercel/path0/app/pages/enterprise.vue"),
    children: [
  {
    name: "enterprise-jobs",
    path: "jobs",
    meta: jobsui3znLVjPPi1uvIO7NuS_QJIZwM8xy_LgNPI4ttmQTUMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/jobs.vue")
  },
  {
    name: "enterprise-support",
    path: "support",
    meta: support7YNSDjkZ1vNxFq7kPcTjA0Ia5kB_rl9F5fxFoZzHiPQMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/support.vue")
  },
  {
    name: "enterprise-sponsors",
    path: "sponsors",
    meta: sponsorsqSnf0SJ24yxiQ_ITbF0iFg2TQ4pmCaAwaGHmnSOJVgMMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/sponsors.vue")
  },
  {
    name: "enterprise-agencies",
    path: "agencies",
    meta: indexdh5KEN3wnXEhpLEGUlAG2S9f0rx3sSUyx4CAF6Uvbw8Meta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/agencies/index.vue")
  },
  {
    name: "enterprise-agencies-slug",
    path: "agencies/:slug()",
    meta: _91slug_93JKyIiTBK8ePEQRrGalD6GzjrE_k30_eVSubgbkdVX6QMeta || {},
    component: () => import("/vercel/path0/app/pages/enterprise/agencies/[slug].vue")
  }
]
  },
  {
    name: "newsletter",
    path: "/newsletter",
    meta: newslettern4GOb5QWXQJ5kM06NFdIlERlYnW_9hqvAMGSs5DZn3kMeta || {},
    component: () => import("/vercel/path0/app/pages/newsletter.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexQYufR705eSA0Alb_DtstO3BC68H4U3RBsMP5nSZmzYAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/vercel/path0/app/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    meta: { ...(loginOl84J9_AHH9A75q8OlyZtme3OFntWQgXeSBZ5ez230UMeta || {}), ...{"middleware":"guest"} },
    component: () => import("/vercel/path0/app/pages/admin/login.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    meta: _91slug_93V5fV_c16JVJ6sOuGL8Wo8dfppaMqN_wRcqM9kt2Zm5YMeta || {},
    component: () => import("/vercel/path0/app/pages/blog/[slug].vue")
  },
  {
    name: "deploy",
    path: "/deploy",
    meta: indexicxDjlXg087w7w6CUqyqwMldMLtROSaz6jMBwBw1JcUMeta || {},
    component: () => import("/vercel/path0/app/pages/deploy/index.vue")
  },
  {
    name: "deploy-slug",
    path: "/deploy/:slug()",
    meta: _91slug_93_ksw8fq6FRuQ4uaNnbYgAzfG0fklryQ204pz9_RDvaUMeta || {},
    component: () => import("/vercel/path0/app/pages/deploy/[slug].vue")
  },
  {
    name: "modules",
    path: "/modules",
    meta: indexujR_H8Cu1L2s4oCJBKSzWX3Bn1mbWcGA_oIqsbBAGR8Meta || {},
    component: () => import("/vercel/path0/app/pages/modules/index.vue")
  },
  {
    name: "video-courses",
    path: "/video-courses",
    meta: video_45coursesNEh0ujp9_IaJpKCGLKWycaqjaVK9Cj04AvwlHbaheL8Meta || {},
    component: () => import("/vercel/path0/app/pages/video-courses.vue")
  },
  {
    name: "docs-slug",
    path: "/docs/:slug(.*)*",
    meta: _91_46_46_46slug_93OUNKk7AMQ1VVXePpxx0zUP0UVhd9HLJ7HMG1pdCiK_IMeta || {},
    component: () => import("/vercel/path0/app/pages/docs/[...slug].vue")
  },
  {
    name: "modules-slug",
    path: "/modules/:slug()",
    meta: _91slug_93br5bsBMaFUldu9ZW3X_bIirDQhXcQ74oasqLdJl3UNUMeta || {},
    component: () => import("/vercel/path0/app/pages/modules/[slug].vue")
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/getting-started",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/getting-started",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/getting-started",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/guide/concepts",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/concepts",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/concepts",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/guide/directory-structure",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/guide/going-further",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/going-further",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/going-further",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/guide/going-further/edge-release-channel",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/going-further/edge-release-channel",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/going-further/edge-release-channel",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/bridge",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/bridge",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/bridge",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/migration",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/migration",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/migration",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/api/components",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/api/components",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/api/components",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/api/composables",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/api/composables",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/api/composables",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/api/utils",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/api/utils",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/api/utils",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/api/kit",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/api/kit",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/api/kit",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/api/commands",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/api/commands",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/api/commands",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/api/advanced",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/api/advanced",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/api/advanced",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/api/configuration/nuxt-config",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/api/configuration/nuxt-config",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/api/configuration/nuxt-config",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/examples",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/examples",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/examples",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/examples/features",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/examples/features",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/examples/features",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/examples/routing",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/examples/routing",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/examples/routing",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/examples/advanced",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/examples/advanced",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/examples/advanced",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/examples/experimental",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/examples/experimental",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/examples/experimental",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/community",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/community",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/community",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/community/nuxt-community",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/community/nuxt-community",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/community/nuxt-community",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/guide/recipes",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/recipes",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/recipes",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/guide/best-practices",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/best-practices",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/best-practices",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/guide/going-further/custom-routing",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/going-further/custom-routing",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/going-further/custom-routing",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/directory-structure/app/middleware",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/directory-structure/app",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/:pathMatch(.*)",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/assets",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/assets",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/components",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/components",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/composables",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/composables",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/layouts",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/layouts",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/middleware",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/middleware",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/pages",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/pages",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/plugins",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/plugins",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/utils",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/utils",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure-config/app",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/guide/directory-structure/app-config",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/3.x/guide/directory-structure/app/error",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/error",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxt",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/output",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/assets",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/components",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/composables",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/layouts",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/middleware",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/pages",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/plugins",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/utils",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/app",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/app-config",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/app/error",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/content",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/modules",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/node_modules",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/public",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/server",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/shared",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/env",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/gitignore",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxtignore",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxtrc",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/nuxt-config",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/package",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/directory-structure/tsconfig",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/support/us",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  },
  {
    name: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwkMeta?.name,
    path: "/docs/4.x/guide/ai",
    component: component_45stube3X_fwEfmA_YIQpjnnwQ1JIbQT_ILQYgNxidFNv2vwk
  }
]